import { useMemo } from 'react';
import { useLastSignRequest } from 'app/domains/esigning/hooks/useLastSignRequest';
export const useSignatories = () => {
    const { lastSignRequest } = useLastSignRequest();
    const signatories = (lastSignRequest === null || lastSignRequest === void 0 ? void 0 : lastSignRequest.signatories) || [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => signatories, [lastSignRequest]);
};
